//泰语
export default{
  首页:"หน้าแรก",
  我的资产:"ทรัพย์สินของฉัน",
  重置登录密码:"รีเซ็ตรหัสผ่านเข้าสู่ระบบ",
  重置登录密码后:"หลังจากรีเซ็ตรหัสผ่านเข้าสู่ระบบแล้ว ห้ามถอนสกุลเงินและโอน OTC ภายใน 24 ชั่วโมง",
  请选择:"กรุณาเลือก",
  密码在:"รหัสผ่านอยู่ระหว่าง 6-16 ตัวอักษรและประกอบด้วยตัวเลขและตัวอักษร",
  请确认密码:"กรุณายืนยันรหัสผ่านของคุณ",
  产品列表:"รายการสินค้า",
  币种:"สกุลเงิน",
  期限:"ระยะ",
  订单列表:"รายการสั่งซื้อ",
  交易用:"สำหรับการซื้อขาย",
  立即入金开始您的第一笔交易:"ฝากเงินตอนนี้เพื่อเริ่มการซื้อขายครั้งแรกของคุณ",
  立即入金:"ฝากเลย",
  币种对:"คู่สกุลเงิน",
  涨幅:"เพิ่มขึ้น",
  交易量:"ปริมาณการซื้อขาย",
  欢迎登录:"กรุณาเข้าสู่ระบบ",
  登录:"เข้าสู่ระบบ",
  新用户注册:"การลงทะเบียนผู้ใช้ใหม่",
  总资产折合:"สินทรัพย์ทั้งหมดที่แปลงแล้ว",
  冻结:"แช่แข็ง",
  折合:"แปลงแล้ว",
  充值币种:"เติมเงินสกุลเงิน",
  充值数量:"ปริมาณการเติมเงิน",
  确认信息:"ยืนยันข้อมูล",
  充币网络:"เครือข่ายเงินฝาก",
  欢迎注册:"ยินดีต้อนรับสู่การลงทะเบียน",
  点击打开:"คลิกเพื่อเปิด",
  这是一段信息:"นี่เป็นข้อมูลชิ้นหนึ่ง",
  提币数量:"จำนวนเหรียญที่ถอนออก",
  提币:"ถอนเหรียญ",
  百万用户首选:"ตัวเลือกแรกของผู้ใช้หลายล้านคน",
  小时成交量:"ปริมาณการซื้อขายตลอด 24 ชั่วโมง",
  优质数字资产:"สินทรัพย์ดิจิทัลคุณภาพสูง",
  我们的核心产品:"ผลิตภัณฑ์หลักของเรา",
  你可以选择丰富的交易方式:"คุณสามารถเลือกวิธีการซื้อขายที่หลากหลาย",
  现货:"จุดสินค้า",
  我们提供:"เราจัดให้",
  币种的交易服务:"บริการซื้อขายสกุลเงิน",
  合约:"สัญญา",
  使用合约丰富你的交易体验:"ใช้สัญญาเพื่อเพิ่มประสบการณ์การซื้อขายของคุณ",
  赚币:"รับเหรียญ",
  行业内领先收益:"รายได้ชั้นนำของอุตสาหกรรม",
  多元化的产品服务:"สินค้าและบริการที่หลากหลาย",
  选择更多:"เลือกบริการเพิ่มเติมและสำรวจความเป็นไปได้ที่ไม่มีที่สิ้นสุด",
  福利中心:"ศูนย์สวัสดิการ",
  完成新手任务:"ทำงานมือใหม่ให้สำเร็จ",
  会员:"สมาชิก",
  享受全网最多权益:"เพลิดเพลินกับสิทธิประโยชน์สูงสุดบนเครือข่ายทั้งหมด",
  社区:"ชุมชน",
  在这里发现币圈财富机会:"ค้นพบโอกาสความมั่งคั่งในแวดวงสกุลเงินได้ที่นี่",
  随时随地开启交易:"เริ่มซื้อขายได้ทุกที่ทุกเวลา",
  全面支持:"การสนับสนุนอย่างเต็มที่",
  和:"และ",
  交割:"จัดส่ง",
  关于我们:"เกี่ยวกับเรา",
  账变记录:"บันทึกการเปลี่ยนแปลงบัญชี",
  股票:"คลังสินค้า",
  加密货币:"สกุลเงินดิจิทัล",
  加载中:"กำลังโหลด...",
  已经全部加载完毕:"มีการโหลดทั้งหมดแล้ว",
  暂无记录:"ไม่มีบันทึก",
  高级认证:"การรับรองขั้นสูง",
  姓名:"ชื่อ",
  请输入姓名:"กรุณาพิมพ์ชื่อของคุณ",
  护照编号:"หมายเลขหนังสือเดินทาง",
  请输入护照编号:"กรุณากรอกหมายเลขหนังสือเดินทาง",
  护照照片:"ภาพถ่ายหนังสือเดินทาง",
  申请认证:"สมัครขอใบรับรอง",
  提示:"คำใบ้",
  确定:"แน่นอน",
  提交失败:"การส่งล้มเหลว",
  上传失败:"การอัพโหลดล้มเหลว",
  身份认证:"การรับรองความถูกต้อง",
  身份证号:"หมายเลขประจำตัวประชาชน",
  请输入身份证号:"กรุณากรอกหมายเลขประจำตัว",
  身份证照片:"รูปถ่ายประจำตัว",
  申请认证:"สมัครขอใบรับรอง",
  修改资金密码:"เปลี่ยนรหัสผ่านกองทุน",
  旧密码:"รหัสผ่านเก่า",
  请输入旧密码:"กรุณากรอกรหัสผ่านเก่า",
  新密码:"รหัสผ่านใหม่",
  请输入6位数字:"กรุณากรอกตัวเลข 6 หลัก",
  确认新密码:"ยืนยันรหัสผ่านใหม่",
  请再次输入新密码:"กรุณากรอกรหัสผ่านใหม่อีกครั้ง",
  提交:"ส่ง",
  请输入新密码:"กรุณากรอกรหัสผ่านใหม่",
  请输入6位数新密码:"กรุณากรอกรหัสผ่าน 6 หลักใหม่",
  请确认两次密码输入一致:"โปรดยืนยันว่ารหัสผ่านทั้งสองที่ป้อนมีความสอดคล้องกัน",
  修改登录密码:"เปลี่ยนรหัสผ่านเข้าสู่ระบบ",
  密码长度:"รหัสผ่าน (6-12 ตัวอักษร)",
  密码长度提示:"กรุณากรอกอักขระ 6-12 ตัว รวมทั้งตัวเลขหรือตัวอักษร",
  客服:"บริการลูกค้า",
  永续:"ที่ยั่งยืน",
  交割:"จัดส่ง",
  永续合约:"สัญญาถาวร",
  交割合约:"สัญญาส่งมอบ",
  全仓:"โกดังเต็ม",
  开多:"เปิดยาวๆ",
  开空:"เปิดสั้น",
  价格:"ราคา",
  开仓金额:"จำนวนเปิด",
  可用金额:"จำนวนเงินที่มีอยู่",
  合约金额:"จำนวนเงินตามสัญญา",
  保证金:"ระยะขอบ",
  手续费:"ค่าธรรมเนียมการจัดการ",
  看涨:"รั้น",
  看跌:"งุ่มง่าม",
  交割时间:"เวลาการส่งมอบ",
  数量:"ปริมาณ",
  持有仓位:"ดำรงตำแหน่ง",
  当前委托:"คำสั่งซื้อปัจจุบัน",
  历史订单:"คำสั่งทางประวัติศาสตร์",
  暂无数据:"ไม่มีข้อมูล",
  购买价:"ราคาซื้อ",
  市价: "ราคาตลาด",
  限价: "ขีด จำกัด ราคา",
  现价:"ราคาปัจจุบัน",
  金额:"จำนวน",
  盈亏:"กำไรและขาดทุน",
  操作:"ดำเนินงาน",
  平仓:"ปิดตำแหน่ง",
  撤单:"ยกเลิกคำสั่งซื้อ",
  方向:"ทิศทาง",
  剩余时间:"เวลาที่เหลือ",
  交割时间:"เวลาการส่งมอบ",
  详情:"รายละเอียด",
  名称:"ชื่อ",
  最新价格:"ราคาล่าสุด",
  h24涨跌:"ขึ้นและลงตลอด 24 ชั่วโมง",
  h24涨跌幅:"เพิ่มขึ้นและลดลง 24 ชั่วโมง",
  请输入开仓金额:"กรุณากรอกจำนวนเงินเปิด",
  请输入开仓价格:"กรุณาระบุราคาเปิด",
  确定执行撤单操作:"คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคำสั่งซื้อ",
  确定执行平仓操作:"คุณแน่ใจหรือว่าจะดำเนินการปิดสถานะ?",
  交割合约历史:"ประวัติสัญญาการส่งมอบ",
  历史仓位:"ตำแหน่งทางประวัติศาสตร์",
  到期时间:"วันที่หมดอายุ",
  闪兑:"การแลกเปลี่ยนแฟลช",
  从:"จาก",
  最大:"ขีดสุด",
  可用数量:"ปริมาณที่มีอยู่",
  至:"ถึง",
  复制成功:"คัดลอกเรียบร้อยแล้ว",
  基金理财:"การจัดการทางการเงินของกองทุน",
  托管金额:"จำนวนเงินที่เอสโครว์",
  总收益:"รายได้รวม",
  当日收益:"รายได้ของวัน",
  托管订单:"คำสั่งเอสโครว์",
  规则:"กฎ",
  日收益:"รายได้รายวัน",
  限额:"ขีด จำกัด",
  周期:"วงจร",
  天:"ท้องฟ้า",
  立即买入:"ซื้อตอนนี้",
  购买:"ซื้อ",
  购买日:"วันที่ซื้อ",
  起息日:"วันที่มีค่า",
  派息时间:"ระยะเวลาการจ่ายเงินปันผล",
  每日:"รายวัน",
  计息结束日:"วันสิ้นสุดการคิดดอกเบี้ย",
  提前赎回:"การไถ่ถอนก่อนกำหนด",
  预计收益:"รายได้โดยประมาณ",
  今日日收益:"วันนี้ (รายได้รายวัน)",
  最少可投:"การลงทุนขั้นต่ำ",
  最大可投:"การลงทุนสูงสุด",
  请输入买入金额:"กรุณากรอกจำนวนเงินที่ซื้อ",
  可用金额:"จำนวนเงินที่มีอยู่",
  请输入买入金额:"กรุณากรอกจำนวนเงินที่ซื้อ",
  质押金额:"จำนวนจำนำ",
  累计收益:"รายได้สะสม",
  开始时间:"เวลาเริ่มต้น",
  结束时间:"เวลาสิ้นสุด",
  理财规则:"กฎเกณฑ์ทางการเงิน",
  理财规则1:"การจัดการทางการเงินทำได้โดยการมอบความไว้วางใจให้กับแพลตฟอร์ม USDT และทีมงานมืออาชีพของแพลตฟอร์มก็ดำเนินการเก็งกำไรทางการเงิน ผู้เข้าร่วมสามารถรับส่วนแบ่งรายได้จากการจัดการทางการเงินของแพลตฟอร์มได้ในช่วงระยะเวลาการดูแลกองทุน",
  收益计算:"การคำนวณรายได้",
  理财规则2:"สมาชิกฝากเงิน 10,000U บนแพลตฟอร์มและเลือกผลิตภัณฑ์ทางการเงินที่มีรอบ 5 วันและรายได้รายวัน 0.3%~0.5% รายได้รายวันมีดังนี้:",
  最低:"ต่ำสุด",
  最高:"สูงสุด",
  理财规则3:"ทั้งสอง: คุณสามารถรับได้หลังจาก 5 วัน",
  理财规则4:"รายได้จะถูกกระจายทุกวัน คุณสามารถเข้าถึงและถอนรายได้ที่กระจายได้ตลอดเวลาและฝากเข้าเงินต้น เมื่อครบกำหนด รายได้จะถูกส่งกลับเข้าบัญชีของคุณโดยอัตโนมัติ",
  关于违约金:"เกี่ยวกับค่าเสียหายที่ชำระบัญชีแล้ว",
  理财规则5:"หากคุณต้องการโอนเงินต้นที่ยังไม่หมดอายุ จะต้องเสียค่าเสียหายจากการชำระหนี้",
  理财规则6:"ความเสียหายที่ชำระบัญชี = อัตราส่วนการชำระหนี้ x วันที่เหลือ x จำนวนเงินลงทุน",
  理财规则7:"ตัวอย่าง: อัตราส่วนการชำระหนี้ความเสียหายที่ชำระบัญชีของผลิตภัณฑ์นี้คือ",
  剩余:"ที่เหลืออยู่",
  天到期投资:"จะหมดอายุในไม่กี่วัน และจำนวนเงินลงทุนคือ",
  则:"แต่",
  违约金:"ค่าเสียหายที่ชำระบัญชีแล้ว",
  实际退还本金为:"เงินต้นที่คืนจริงคือ",
  现货账户:"บัญชีสปอต",
  总资产:"สินทรัพย์รวม",
  充币:"ฝากเหรียญ",
  提币:"ถอนเหรียญ",
  闪兑:"การแลกเปลี่ยนแฟลช",
  投资组合:"ผลงาน",
  冻结数量:"ปริมาณแช่แข็ง",
  帮助中心:"ศูนย์ช่วยเหลือ",
  自选:"ไม่จำเป็น",
  行情:"คำคม",
  资金:"กองทุน",
  资讯:"ข้อมูล",
  我的:"ของฉัน",
  交易对:"คู่การซื้อขาย",
  最新价:"ราคาล่าสุด",
  成交量:"ปริมาณ",
  标记价格:"ราคาทำเครื่องหมาย",
  h24最高价:"ราคาสูงสุด 24 ชม",
  h24最低价:"ราคาต่ำสุด 24 ชม",
  h24成交量:"ปริมาณการซื้อขายตลอด 24 ชั่วโมง",
  h24交易额:"ปริมาณธุรกรรม 24 ชม",
  分时:"การแบ่งปันเวลา",
  分1:"1 คะแนน",
  分5:"5 คะแนน",
  分15:"15 คะแนน",
  分30:"30 คะแนน",
  小时1:"1 ชั่วโมง",
  天1:"1 วัน",
  周1:"1 สัปดาห์",
  月1:"มกราคม",
  委托订单:"คำสั่ง",
  最新交易:"การทำธุรกรรมล่าสุด",
  买入:"ซื้อ",
  卖出:"ขาย",
  时间:"เวลา",
  方向:"ทิศทาง",
  取消自选成功:"ยกเลิกการเลือกเรียบร้อยแล้ว",
  添加成功:"เพิ่มเรียบร้อยแล้ว",
  登录:"เข้าสู่ระบบ",
  账户:"บัญชี",
  邮箱:"จดหมาย",
  手机号:"หมายเลขโทรศัพท์",
  请输入账户:"กรุณากรอกบัญชี",
  请输入邮箱:"กรุณากรอกอีเมล์ของคุณ",
  请输入手机号:"กรุณากรอกหมายเลขโทรศัพท์",
  密码:"รหัสผ่าน",
  请输入密码:"กรุณากรอกรหัสผ่าน",
  忘记密码:"ลืมรหัสผ่านเหรอ?",
  还没有账号:"ยังไม่มีบัญชี",
  去注册:"ไปลงทะเบียน",
  请输入登录账号:"กรุณากรอกบัญชีเข้าสู่ระบบของคุณ",
  请输入登录密码:"กรุณาใส่รหัสผ่านของคุณ",
  登录失败:"การเข้าสู่ระบบล้มเหลว",
  历史记录:"บันทึกประวัติศาสตร์",
  充值:"เติม",
  提现:"ถอน",
  未审核:"ไม่ได้รับการตรวจทาน",
  成功:"ความสำเร็จ",
  失败:"ล้มเหลว",
  快捷入口:"เข้าด่วน",
  资金密码:"รหัสผ่านกองทุน",
  登录密码:"รหัสผ่านการเข้าใช้งาน",
  账变记录:"บันทึกการเปลี่ยนแปลงบัญชี",
  邀请推广:"เชิญชวนโปรโมท",
  通用:"สากล",
  语言:"ภาษา",
  在线客服:"บริการออนไลน์",
  身份认证:"การรับรองความถูกต้อง",
  高级认证:"การรับรองขั้นสูง",
  更多:"มากกว่า",
  帮助中心:"ศูนย์ช่วยเหลือ",
  关于我们:"เกี่ยวกับเรา",
  退出:"ล้มเลิก",
  已提交身份认证:"คุณได้ส่งข้อมูลประจำตัวของคุณและอยู่ระหว่างการตรวจสอบ",
  您已完成身份认证:"คุณได้ทำการยืนยันตัวตนเรียบร้อยแล้ว",
  您已完成高级认证:"คุณผ่านการรับรองขั้นสูงแล้ว",
  确定退出登录:"คุณแน่ใจว่าคุณต้องการที่จะออกจากระบบ?",
  资讯:"ข้อมูล",
  公告:"ประกาศ",
  状态:"สถานะ",
  已成交:"จัดการเรียบร้อยแล้ว",
  委托金额:"จำนวนค่าคอมมิชชั่น",
  剩余金额:"สมดุล",
  订单类型:"ประเภทการสั่งซื้อ",
  市价委托:"คำสั่งซื้อของตลาด",
  限价委托:"คำสั่งจำกัด",
  订单号:"หมายเลขคำสั่งซื้อ",
  委托时间:"เวลาคอมมิชชั่น",
  U本位合约历史:"ประวัติสัญญาแบบ U",
  成交数量:"จำนวนธุรกรรม",
  实现盈亏:"ตระหนักถึงผลกำไรและขาดทุน",
  推广记录:"บันทึกการส่งเสริมการขาย",
  我的总推广:"โปรโมชั่นทั่วไปของฉัน",
  总充值:"เติมเงินทั้งหมด",
  一代人数:"จำนวนรุ่น",
  二代人数:"จำนวนรุ่นที่สอง",
  三代人数:"จำนวนสามชั่วอายุคน",
  立即推广:"โปรโมทเลย",
  我的推广:"โปรโมชั่นของฉัน",
  用户名:"ชื่อผู้ใช้",
  行情:"คำคม",
  加密货币:"สกุลเงินดิจิทัล",
  外汇:"ฟอเร็กซ์",
  股票:"คลังสินค้า",
  现货交易:"การซื้อขายแบบสปอต",
  热门:"เป็นที่นิยม",
  涨幅榜:"รายการกำไร",
  跌幅榜:"รายชื่อผู้แพ้",
  快速充币:"ฝากด่วน",
  保存二维码:"บันทึกรหัส QR",
  复制地址:"คัดลอกที่อยู่",
  转出地址:"ที่อยู่สำหรับการโอนออก (ไม่บังคับ)",
  请输入转出地址:"กรุณากรอกที่อยู่ในการโอนออก",
  粘贴:"แปะ",
  充币数量:"จำนวนเงินฝาก",
  请输入充币数量:"กรุณากรอกจำนวนเงินฝาก",
  区块链网络:"เครือข่ายบล็อคเชน",
  付款凭证:"ใบสำคัญการชำระเงิน (อัพโหลดภาพหน้าจอรายละเอียดการชำระเงิน)",
  请输入充值数量:"กรุณากรอกจำนวนเงินที่เติม",
  充值通道:"ช่องเติมเงิน",
  请选择充值币种:"โปรดเลือกสกุลเงินที่เติมเงิน",
  官方充值通道:"ช่องทางการเติมเงินอย่างเป็นทางการ",
  设置密码:"ตั้งรหัสผ่าน",
  确认密码:"ยืนยันรหัสผ่าน",
  验证码:"รหัสยืนยัน",
  请输入验证码:"กรุณากรอกรหัสยืนยัน",
  获取验证码:"รับรหัสยืนยัน",
  重新发送:"ส่งซ้ำ",
  邀请码:"รหัสการเชิญ",
  请输入邀请码:"กรุณากรอกรหัสเชิญ",
  我已阅读并同意:"ฉันได้อ่านและเห็นด้วย",
  服务条款:"เงื่อนไขการให้บริการ",
  注册:"ลงทะเบียน",
  已有账号:"มีบัญชีอยู่แล้ว",
  去登录:"ไปที่เข้าสู่ระบบ",
  请再次输入密码:"กรุณากรอกรหัสผ่านอีกครั้ง",
  请同意服务条款:"โปรดยอมรับข้อกำหนดในการให้บริการ",
  注册失败:"การลงทะเบียนไม่สำเร็จ",
  欢迎来到:"ยินดีต้อนรับสู่",
  全球最大的区块链资产平台:"แพลตฟอร์มสินทรัพย์บล็อคเชนที่ใหญ่ที่สุดในโลก",
  分享二维码:"แบ่งปันรหัส QR",
  链接分享:"การแชร์ลิงก์",
  复制:"สำเนา",
  您的邀请码:"รหัสเชิญของคุณ",
  到数字币地址:"ไปยังที่อยู่สกุลเงินดิจิทัล",
  选择币种:"เลือกสกุลเงิน",
  区块链网络:"เครือข่ายบล็อคเชน",
  提币说明:"คำแนะนำในการถอนเงิน",
  提现费用:"ค่าธรรมเนียมการถอนเงิน",
  可到账数量:"ปริมาณที่มีอยู่",
  可用:"มีอยู่",
  请输入支付密码:"กรุณากรอกรหัสผ่านการชำระเงิน",
  请输入提币数量:"กรุณากรอกจำนวนเงินที่ถอน",
  全部:"ทั้งหมด",
  支付密码:"รหัสผ่านการชำระเงิน",
  地址:"ที่อยู่",
  委托价:"ราคาสั่ง",
  成交时间:"เวลาทำธุรกรรม",
  成交金额:"มูลค่าการซื้อขาย",
  委托中:"ในค่าคอมมิชชั่น",
  持仓中:"ในตำแหน่ง",
  平仓中:"การปิดตำแหน่ง",
  已平仓:"ปิดตำแหน่งแล้ว",
  开仓倍数:"เปิดหลายอัน",
  委托价格:"ราคาคอมมิชชั่น",
  收盘价:"ราคาปิด",
  收益率:"อัตราผลตอบแทน",
  平仓时间:"เวลาปิด",
  请输入转换数量:"กรุณากรอกปริมาณการแปลง",
  请上传付款凭证:"กรุณาอัพโหลดใบสำคัญการชำระเงิน",
  开盘价:"ราคาเปิด",
  开市中:"เปิด",
  已休市:"ตลาดปิดแล้ว",
  美股:"หุ้นสหรัฐ",
  平仓价:"ราคาปิด",
  到期结算完成:"การชำระหนี้ครบกำหนดเสร็จสมบูรณ์",
  印度股票:"หุ้นอินเดีย",
  马来股票:"หุ้นมาเลย์",
  结算中:"กำลังปักหลัก",
  越南股票:"หุ้นเวียดนาม",
  设置资金密码:"ตั้งรหัสผ่านกองทุน",
  请输入资金密码:"กรุณากรอกรหัสผ่านกองทุน",
  取消:"ยกเลิก",
  确定:"แน่นอน",
  止损价:"หยุดราคาขาดทุน",
  请输入止损价格:"กรุณากรอกราคาหยุดขาดทุน",
  请输入止盈价格:"กรุณากรอกราคาขายทำกำไร",
  止盈价:"ราคาขายทำกำไร",
  设置止盈止损:"ตั้งค่า Take Profit และ Stop Loss",
  请输入关键词:"กรุณากรอกคำสำคัญ",
  搜索结果:"ผลการค้นหา",
  添加收款方式:"เพิ่มวิธีการชำระเงิน",
  高级认证:"การรับรองขั้นสูง",
  历史委托:"คณะกรรมการประวัติศาสตร์",
  选择区域码:"เลือกรหัสพื้นที่",
  请上传身份证图片:"กรุณาอัพโหลดรูปภาพบัตรประจำตัวประชาชนของคุณ",
  请上传护照照片:"กรุณาอัพโหลดรูปถ่ายหนังสือเดินทาง",
  请输入提币地址:"กรุณากรอกที่อยู่การถอนเงิน",
  设置语言:"การตั้งค่าภาษา",
  最低金额: "จำนวนขั้นต่ำ",
  购买金额: "ราคาซื้อ",
  请输入要搜索的国家名称: "กรุณากรอกชื่อประเทศที่คุณต้องการค้นหา",
  确定执行该操作: "ยืนยันการดำเนินการนี้?",
  历史搜索: "การค้นหาทางประวัติศาสตร์",
  现货持仓: "ตำแหน่งจุด",
  永续持仓: "ตำแหน่งถาวร",
  到期结算中: "ปักหลักเมื่อครบกำหนด",
  火花图: "แผนภาพประกายไฟ",
  计价单位: "หน่วยการขาย",
  您拒绝了链接: "คุณปฏิเสธการเชื่อมโยง",
  连接钱包成功: "การเชื่อมต่อกระเป๋าเงินสำเร็จ",
  已断开钱包: "กระเป๋าสตางค์ถูกตัดการเชื่อมต่อ",
  钱包切换成功: "สลับกระเป๋าเงินสำเร็จ",
  请先安装钱包插件: "โปรดติดตั้งปลั๊กอินกระเป๋าสตางค์ก่อน",
  连接钱包: "เชื่อมต่อกระเป๋าสตางค์",
  交易: "ซื้อขาย",
  确认报价: "ยืนยันใบเสนอราคา",
  您将获得: "คุณจะได้รับ",
  兑换自: "แลกจาก",
  汇率: "อัตราแลกเปลี่ยน",
  返回: "กลับ",
  兑换: "แลกเปลี่ยน",
  消息: "ข้อมูล",
  身份证反面照片: "ภาพถ่ายด้านหลังของบัตรประจำตัวประชาชน",
  身份证正面照片: "ภาพถ่ายด้านหน้าบัตรประจำตัวประชาชน",
  手持身份证照片: "ภาพถ่ายการถือบัตรประจำตัวประชาชน",
  划转: "โอนย้าย",
  请输入划转数量: "กรุณากรอกจำนวนเงินที่โอน(USDT)",
  邀请链接: "ลิงค์คำเชิญ",
  资料总览: "ภาพรวมข้อมูล",
  推广规则: "กฎโปรโมชั่น",
  总邀请人数: "จำนวนผู้ได้รับเชิญทั้งหมด",
  总佣金: "ค่าคอมมิชชั่นทั้งหมด",
  安全绑定: "มีผลผูกพันที่ปลอดภัย",
  规则1: "1.ที่อยู่นี้ยอมรับเฉพาะ {type} เท่านั้น โปรดอย่าโอนสินทรัพย์ที่ไม่ใช่ {type} ไปยังที่อยู่นี้ มิฉะนั้น สินทรัพย์จะไม่ถูกเรียกคืน",
  规则2: "2.หลังจากที่คุณเติมเงินที่อยู่ข้างต้นแล้ว คุณจะต้องรอให้โหนดเครือข่ายยืนยัน เมื่อโหนดเครือข่ายยืนยัน ทรัพย์สินจะเข้าบัญชีของคุณโดยอัตโนมัติ เราจะแจ้งสถานะการมาถึงให้คุณทราบในรูปแบบประกาศบนเว็บไซต์",
  规则3: "3.ที่อยู่การเติมเงินของคุณจะไม่เปลี่ยนแปลงบ่อยและคุณสามารถเติมเงินซ้ำได้หากมีการเปลี่ยนแปลงเราจะแจ้งให้คุณทราบผ่านประกาศบนเว็บไซต์",

  安全中心: "ศูนย์รักษาความปลอดภัย",
  绑定手机号: "ผูกเบอร์มือถือ",
  认证中心: "ศูนย์รับรอง",
  身份认证: "การรับรองความถูกต้อง",
  认证要求: "ข้อกำหนดการรับรอง",
  政府发行的证件: "เอกสารที่ทางราชการออกให้",
  功能与限制: "คุณสมบัติและข้อจำกัด",
  无限额: "ไม่มีขีด จำกัด",
  预计审核时间: "ระยะเวลาในการทบทวนโดยประมาณ: 60 นาที",
  开始认证: "เริ่มการรับรอง",
  充币规则: "กฎการฝากเงิน",
  加密货币股票多类选择: "หุ้น Cryptocurrency หลายตัวเลือก",
    个人中心: "ศูนย์ส่วนบุคคล",
    充值记录: "บันทึกการเติมเงิน",
    提现记录: "บันทึกการถอนเงิน"
    
  }
  
  
  


// WEBPACK FOOTER //
// ./src/lang/th.js